let deliveryToggler = document.querySelectorAll('.method-toggler')

if(deliveryToggler.length) {
    for(let toggler of deliveryToggler) {
        let tabs = toggler.children
        let methodInputs = document.querySelectorAll('.method-data')

        for(let tab of tabs) {
            tab.addEventListener('click', () => {
                let siblings = tab.siblings()
                let {type} = tab.dataset

                tab.classList.add('active')

                for(let sibling of siblings) {
                    sibling.classList.remove('active')
                }

                if(methodInputs.length) {
                    for(let item of methodInputs) {
                        if(item.dataset.type == type) {
                            item.classList.add('active')
                        } else {
                            item.classList.remove('active')
                        }
                    }
                }
            })
        }
    }
}

/////

let sendBtns = document.querySelectorAll('.order-btn')

if(sendBtns.length) {
    for(let btn of sendBtns) {
        btn.addEventListener('click', (e) => {
            e.preventDefault()

            let btns = document.querySelectorAll('.order-btn')
            let form = document.querySelector('.order-form')
            let fields = {
                name: 1,
                phone: 1,
                address: 1,
                message: 0,
            }
            let delivery = document.querySelector('.method-toggler.delivery .active').dataset.type
            let payment = document.querySelector('.method-toggler.payment .active').dataset.type
            let data = {delivery, payment}
            let errors = 0

            if(payment == 'cash') {
                fields.deposit = 0
            } else {
                fields.kaspi = 0
            }

            if(delivery == 'pickup') {
                fields.address = 0
            }

            if(btn.classList.contains('scroll')) {
                form.scrollIntoView({ 
                    behavior: 'smooth' 
                })
            }
        
            for(let key in fields) {
                let required = fields[key]
                let field = form.querySelector('.' + key)
        
                if(field) {
                    let value = field.getValue()
        
                    if(required) {
                        errors += field.check()
                    } else {
                        field.classList.remove('error')
                    }
        
                    data[key] = value
                }
            }
        
            if(!errors) {
                for(let btn of btns) {
                    btn.disable(true)
                }
                
                sendOrder(data, true, () => {
                    if(!window.debug) {
                        window.location.href = '/success/?type=order'
                    }
                })
            }
        })
    }
}

function sendOrder(fields, products, callback) {
    let type = fields.type || 'order'
    products = products ? 1 : 0

    fields.type = type

    requestAxios('axiosSendOrder', {type, fields, products}, () => {
        if(callback) {
            callback()
        }
    })
}

function cartStartLoading() {
    let cartProducts = document.querySelector('.cart-products')
    let cartBtns = document.querySelectorAll('.order-btn')
    
    if(cartProducts && !cartProducts.querySelector('.loading-layer')) {
        cartProducts.startLoading()
    }

    if(cartBtns.length) {
        for(let btn of cartBtns) {
            btn.disable()
        }
    }
}

function cartStopLoading() {
    let cartProducts = document.querySelector('.cart-products')
    let cartBtns = document.querySelectorAll('.order-btn')
    
    if(cartProducts) {
        cartProducts.stopLoading()
    }

    if(cartBtns.length) {
        for(let btn of cartBtns) {
            btn.enable()
        }
    }
}

function updateCart() {
    let quantityElements = document.querySelectorAll('.cart-quantity')
    let quantityDataElements = document.querySelectorAll('.cart-quantity-data')
    let priceElements = document.querySelectorAll('.cart-price')
    let priceDataElements = document.querySelectorAll('.cart-price-data')

    cartStartLoading()

    requestAxios('axiosCartInfo', '', (res) => {
        let cartProducts = document.querySelector('.cart-products')
        let cartBtns = document.querySelectorAll('.order-btn')
        let promoWrapper = document.querySelector('.promo-form-wrapper')
        let {cart, session, quantity, price, oldPrice, cartItems, cartItemsData, promoForm} = res

        cartStopLoading()

        if(promoWrapper) {
            promoWrapper.innerHTML = promoForm
            initPromoForm()
        }
        
        if(quantityElements.length) {
            for(let elem of quantityElements) {
                elem.textContent = quantity
            }
        }
                
        if(quantityDataElements.length) {
            for(let elem of quantityDataElements) {
                elem.dataset.count = quantity
            }
        }

        if(priceElements.length) {
            for(let elem of priceElements) {
                elem.textContent = price.toLocaleString()
            }
        }
                
        if(priceDataElements.length) {
            for(let elem of priceDataElements) {
                elem.dataset.price = price.toLocaleString()
            }
        }

        if(cartBtns.length) {
            for(let btn of cartBtns) {
                if(price >= window.minPrice) {
                    btn.removeAttribute('disabled')
                } else {
                    btn.setAttribute('disabled', 'disabled')
                }
            }
        }

        if(cartProducts) {
            cartProducts.innerHTML = cartItems

            initQuantityInput()
            initRemoveCartItem()
        }

        let cartData = {}

        for(let item of cart) {
            cartData[item.slug] = item
        }

        window.cart = cartData

        calcCart()
    })
}

function addToCart(slug, variant = 0, quantity = 1, callback) {
    if(variant) {
        slug += '.' + variant
    }

    let data = {slug, quantity}

    requestAxios('axiosAddToCart', data, () => {
        add_notif({
            title: 'Корзина',
            text: 'Товар добавлен в корзину',
            link: '/cart/',
            icon: 'cart',
            timeout: 4000
        })

        if(callback) {
            callback()
        }

        updateCart()
    })
}

function addToCartBtn() {
    let btns = document.querySelectorAll('.add-to-cart:not(.inited)')

    if(btns.length) {
        for(let btn of btns) {
            btn.addEventListener('click', () => {
                let slug = btn.dataset.slug
                let variant = Number(btn.dataset.variant) || 0
                let wrapper = btn.closest('.price-wrapper')
                let quantity = wrapper.querySelector('.quantity-input[data-slug="' + slug + '"]')

                if(quantity) {
                    quantity = quantity.value
                    quantity = Number(quantity)

                    if(isNaN(quantity)) {
                        quantity = 1
                    }
        
                    quantity = Math.round(quantity)
                    quantity = Math.min(100, quantity)
                    quantity = Math.max(1, quantity)
                } else {
                    quantity = 1
                }

                btn.disable(true)
                addToCart(slug, variant, quantity, () => {
                    btn.enable()
                })
            })

            btn.classList.add('inited')
        }
    }
}

addToCartBtn()

function initRemoveCartItem() {
    let btns = document.querySelectorAll('.remove-cart-item:not(.inited)')

    if(btns.length) {
        for(let btn of btns) {
            btn.addEventListener('click', () => {
                let id = btn.dataset.slug
                let wrapper = btn.closest('.products-item')
                let parent = wrapper.parentNode

                requestAxios('axiosRemoveFromCart', {id})
                wrapper.remove()

                delete window.cart[id]

                calcCart()

                if(!parent.children.length) {
                    parent.insertAdjacentHTML('beforeend', `
                    <div class="empty-block">
                        <div class="icon icon-error"></div>
                        <h6>Корзина пуста</h6>
                    </div>
                    `)
                }
            })

            btn.classList.add('inited')
        }
    }
}

initRemoveCartItem()

function calcCart() {
    let data = window.cart
    let promo = window.promo
    let totalQuantity = 0
    let totalPrice = 0
    let totalDiscount = 0
    let totalOldPrice = 0

    let quantityElements = document.querySelectorAll('.cart-quantity')
    let quantityDataElements = document.querySelectorAll('.cart-quantity-data')
    let priceElements = document.querySelectorAll('.cart-price')
    let priceDataElements = document.querySelectorAll('.cart-price-data')
    let oldPriceElements = document.querySelectorAll('.cart-old-price')
    let oldPriceDataElements = document.querySelectorAll('.cart-old-price-data')
    let discountElements = document.querySelectorAll('.cart-discount')
    let discountDataElements = document.querySelectorAll('.cart-discount-data')
    let cartBtns = document.querySelectorAll('.order-btn')
    let mainCartLink = document.querySelector('.cart-btn')

    if(data) {
        for(let item of Object.values(data)) {
            let {slug, oldPricePer, pricePer, quantity} = item
            let totalPricePer = quantity * pricePer
            let totalOldPricePer = quantity * oldPricePer || totalPricePer
            let discount = totalOldPricePer - totalPricePer
            let priceElem = document.querySelector('.product-total-price[data-slug="' + slug + '"]')
            let oldPriceElem = document.querySelector('.product-old-price[data-slug="' + slug + '"]')
            let discountElem = document.querySelector('.product-discount[data-slug="' + slug + '"]')

            totalQuantity += quantity
            totalPrice += totalPricePer
            totalOldPrice += totalOldPricePer
            totalDiscount += discount

            if(priceElem) {
                priceElem.innerHTML = totalPricePer.toLocaleString()
            }

            if(oldPriceElem) {
                oldPriceElem.innerHTML = totalOldPricePer.toLocaleString()
            }

            if(discountElem) {
                discountElem.innerHTML = discount.toLocaleString()
            }
        }
    }

    if(promo) {
        let {discount, type} = promo

        if(type == 'percent') {
            discount = (discount * 0.01) * totalPrice
        }

        discount = Math.round(discount)
        totalPrice = Math.max(0, totalPrice - discount)
        totalDiscount = Math.min(totalOldPrice, totalDiscount + discount)
    }

    if(quantityElements.length) {
        for(let elem of quantityElements) {
            elem.textContent = totalQuantity
        }
    }
            
    if(quantityDataElements.length) {
        for(let elem of quantityDataElements) {
            elem.dataset.count = totalQuantity
        }
    }

    if(priceElements.length) {
        for(let elem of priceElements) {
            elem.textContent = totalPrice.toLocaleString()
        }
    }
            
    if(priceDataElements.length) {
        for(let elem of priceDataElements) {
            elem.dataset.price = totalPrice.toLocaleString()
        }
    }

    if(oldPriceElements.length) {
        for(let elem of oldPriceElements) {
            elem.textContent = totalOldPrice.toLocaleString()
        }
    }
            
    if(oldPriceDataElements.length) {
        for(let elem of oldPriceDataElements) {
            elem.dataset.price = totalOldPrice.toLocaleString()
        }
    }

    if(discountElements.length) {
        for(let elem of discountElements) {
            elem.textContent = totalDiscount.toLocaleString()
        }
    }
            
    if(discountDataElements.length) {
        for(let elem of discountDataElements) {
            elem.dataset.price = totalDiscount.toLocaleString()
        }
    }

    if(cartBtns.length) {
        for(let btn of cartBtns) {
            if(totalPrice && totalPrice >= window.minPrice) {
                btn.removeAttribute('disabled')
            } else {
                btn.setAttribute('disabled', 'disabled')
            }
        }
    }

    if(mainCartLink) {
        if(totalQuantity) {
            mainCartLink.classList.add('active')
        } else {
            mainCartLink.classList.remove('active')
        }
    }
}

calcCart()

let clearCartBtn = document.querySelector('.clear-cart-btn')

if(clearCartBtn) {
    clearCartBtn.addEventListener('click', () => {
        let wrapper = document.querySelector('.cart-products')
        requestAxios('axiosClearCart')

        wrapper.innerHTML = `
        <div class="empty-block">
            <div class="icon icon-error"></div>
            <h6>Корзина пуста</h6>
        </div>
        `

        window.cart = {}
        calcCart()
    })
}